import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChatbotMetrics } from '../../types/chatbot.types';
import { MessageSquare, Users, Clock, AlertTriangle } from 'lucide-react';

interface MetricsDashboardProps {
  metrics: ChatbotMetrics & {
    uniqueUsers?: number;
    avgMessagesPerConversation?: number;
  };
}

export function MetricsDashboard({ metrics }: MetricsDashboardProps) {
  return (
    <div className='grid gap-4 md:grid-cols-2 lg:grid-cols-4'>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Total Conversaciones</CardTitle>
          <MessageSquare className='h-4 w-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>{metrics.totalConversations}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Total Mensajes</CardTitle>
          <Users className='h-4 w-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>{metrics.totalMessages}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Promedio Mensajes</CardTitle>
          <Clock className='h-4 w-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>
            {metrics.avgMessagesPerConversation ?? metrics.avgResponseTime ?? 0}
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Violaciones Límite</CardTitle>
          <AlertTriangle className='h-4 w-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>{metrics.limitViolations ?? 0}</div>
        </CardContent>
      </Card>
    </div>
  );
}
